module.exports = __webpack_public_path__ + "static/media/status-badge-persona.8a4a3dbd.svg";